<template>
  <div class="flex flex-wrap gap-100 mb-100">
    <HighFrequencyGameOptionBadge v-if="prizeTier?.spots">
      {{ $t('highfrequencygame.prizemodaloptions.spots') }}
      <template #value>{{ prizeTier.spots }}</template>
    </HighFrequencyGameOptionBadge>

    <HighFrequencyGameOptionBadge v-if="prizeTier?.wager">
      {{ $t('highfrequencygame.prizemodaloptions.wager') }}
      <template #value>
        {{ formatMoney(prizeTier.wager, { fractionDigits: 0 }) }}
      </template>
    </HighFrequencyGameOptionBadge>

    <template v-if="prizeTier?.prizesPerAddOn">
      <HighFrequencyGameOptionBadge v-for="{ addOn } in prizeTier.prizesPerAddOn" :key="addOn">
        {{ $t(`highfrequencygame.addon.${addOn}`) }}
        <template #outer-value>
          <LcImage v-bind="getImage(addOn)!" alt="" />
        </template>
      </HighFrequencyGameOptionBadge>
    </template>
  </div>
</template>

<script lang="ts" setup>
const ADD_ONS = {
  kenoBonus: 'bonus-active',
  kenoBooster: 'booster-active',
  kenoMultiplier: 'multiplier-active',
} as const

const { getIllustrationMini } = useAsset()
const { prizeTier } = useHighFrequencyGame()

const getImage = (addOnName: string) => {
  if (ADD_ONS[addOnName as keyof typeof ADD_ONS]) {
    const illustrationName = ADD_ONS[addOnName as keyof typeof ADD_ONS]
    return getIllustrationMini(illustrationName)
  }

  return getIllustrationMini('rocket-active')
}
</script>
